import reduceReducers from 'reduce-reducers';
import get from 'lodash/get';

import bentoApi, { baseApiState } from 'bento-ordering/base/reducers/bentoApi';
import { PROMOTIONS as ENTITY } from 'bento-ordering/promotions/constants/entities';
import { formatListResponse } from 'bento-ordering/base/actions/api';
import setupDataFactory from 'bento-ordering/base/reducers/setupDataFactory';
import {
  ADD_TO_CART_SUCCESS,
  EDIT_CART_ITEM_SUCCESS,
  FETCH_CART_FAILURE,
  EDIT_CART_ITEM_REQUEST
} from 'bento-ordering/cart/constants/actionTypes';

const promotionsReducer = (entity, processPayload = payload => payload) => (
  state = baseApiState,
  action
) => {
  switch (action.type) {
    case ADD_TO_CART_SUCCESS: {
      return {
        ...state,
        ...processPayload(action.payload[entity]),
        isFetching: false,
        error: []
      };
    }
    case EDIT_CART_ITEM_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case EDIT_CART_ITEM_SUCCESS: {
      return {
        ...state,
        ...processPayload(action.payload[entity]),
        isFetching: false,
        error: []
      };
    }
    case FETCH_CART_FAILURE: {
      return {
        ...state,
        isFetching: false,
        error: [get(action, 'payload.response.error')]
      };
    }
    default:
      return state;
  }
};
const reducers = reduceReducers(
  bentoApi(ENTITY),
  setupDataFactory(ENTITY, formatListResponse),
  promotionsReducer(ENTITY, formatListResponse)
);

export default reducers;
